/** @jsx React.DOM */
var React = require('react/addons')

var AccountLink = React.createClass({displayName: 'AccountLink',
  render: function() {
    return React.DOM.span(null, 
      React.DOM.a({href: '#/rmc/accounts/' + this.props.id, title: this.props.id}, 
        this.props.id.substr(0, 7)
      )
    )
  }
})

module.exports = AccountLink



//////////////////
// WEBPACK FOOTER
// ./src/partials/rmc/account-link.jsx
// module id = 469
// module chunks = 0